<template>
  <div class="supplier-management">
    <el-row>
    <el-col :span="24" style="text-align: center">
        <img src="../../assets/imgs/psdMachine.svg" style="width: 300px;margin: 41px 0px;"></el-col>
    </el-row>
    <el-row>
     <el-col :span="24" style="text-align: center">
        <p style="font-size: 35px;">请输入仪器编号</p></el-col>
    </el-row>
    <el-row>
      <el-col :span="24" style="text-align: center;">
      <el-input v-model="machine_input" @input="handleInput" placeholder="请输入" style="width: 25%;padding: 3px 0 0 10px;font-size: 20px;"></el-input></el-col>
    </el-row>
    <el-row>
      <el-col :span="24" style="text-align: center;margin: 25px 0 0 0;">
       <el-button type="primary" @click="psdAdd">生成密钥</el-button></el-col>
    </el-row>
    <el-row>
      <el-col :span="24" style="text-align: center;margin: 10px 0 0 0;">
      <p style="font-size:25px">{{psdDetail}}</p>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      machine_input:'',
      psdDetail:''
    }
  },
  created() {
  },

  methods: {
     handleInput() {
      this.psdDetail=''
    },

      psdAdd(){
      this.$api.get('/datacenter/getLanguageKey',{machineNum: this.machine_input}, (res) => {
            if (res.data.code === 200) {
               this.psdDetail=res.data.data
            } else {
              this.$message({
                message: `${res.data.msg}`,
                type: 'error',
              })
            }
          })
      }
  },
}
</script>
<style scoped>

</style>
